function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useEffect, useState } from 'react';
import { FileExcelOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { determineHost, generateTemplate } from '@cryptosheets/util';
export default function TemplateGenerator(_ref) {
  var {
    type = 'excel',
    config
  } = _ref;
  var [disabled, setDisabled] = useState(false);
  useEffect(() => {
    var getHost = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(function* () {
        var currentHost = yield determineHost();

        if (type !== currentHost) {
          setDisabled(true);
        }
      });

      return function getHost() {
        return _ref2.apply(this, arguments);
      };
    }();

    getHost();
  }, []);
  var tooltip = disabled ? "Use Cryptosheets in ".concat(type, " to generate template") : 'Generate Spreadsheet Template';
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: tooltip
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    onClick: () => generateTemplate({
      type,
      config
    }),
    type: "link",
    icon: /*#__PURE__*/React.createElement(FileExcelOutlined, null)
  }));
}